import React, {useState} from 'react';
import {Tag, Upload, UploadFile} from 'antd';
import mammoth from 'mammoth';
import {IoAttachOutline} from 'react-icons/io5';
import {ERROR_MESSAGES, FILE_CONSTANTS} from '@/constants/messages';
import {handleError} from '@/utils/helpers';
import textUpload from "@/pages/AfterMeet/static/textUpload.png";
import {UploadChangeParam} from 'antd/es/upload';

const { Dragger } = Upload;

interface DocxParserProps {
  fList?: UploadFile[];
  fileChange: (fileInfo: UploadChangeParam<UploadFile>) => void;
  setData: (docParam: Record<string, string>) => void;
}

const DocxParser: React.FC<DocxParserProps> = ({ fList, fileChange, setData }) => {
    const [parsedContent, setParsedContent] = useState<Record<string, string>>({  });

    const handleFileRead = async (file: Blob,  name:string) => {
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const result = e.target?.result;
          if (!result || !(result instanceof ArrayBuffer)) {
            throw new Error('文件读取失败');
          }

          // 使用 mammoth 解析 docx 内容
          const parseResult = await mammoth.convertToHtml({ arrayBuffer: result });
          parsedContent[name] = parseResult.value;
          setData(parsedContent);
          // 也可以提取纯文本：
          // const result = await mammoth.extractRawText({ arrayBuffer });
          // setParsedContent(result.value);
        };
        reader.readAsArrayBuffer(file);
      } catch (error) {
        handleError(error, ERROR_MESSAGES.FILE_PARSE_ERROR);
      }
    };

    return (
      // <div style={{ maxWidth: 800, margin: '0 auto' }}>
      <div>
        <Upload
          // showUploadList={false}
          name="file"
          // multiple={false}
          accept={FILE_CONSTANTS.ACCEPTED_DOC_FORMATS}
          beforeUpload={(file) => {
            handleFileRead(file, file.name);
            return false; // 阻止自动上传
          }}
          customRequest={() => {
          }} // 覆盖默认上传行为
          onRemove={false}

          showUploadList={false}
          iconRender={()=><Tag color="cyan-inverse">文本</Tag>}
          maxCount={FILE_CONSTANTS.MAX_UPLOAD_COUNT}
          onChange={info => {
            console.log("txt file change",info);
            fileChange(info);
          }}
          fileList={fList}
        >
          <div className="flex items-center gap-1.5 cursor-pointer">
            <IoAttachOutline className="text-[14px] text-[#73726E]" />
            <span className="text-[11px] text-[#73726E]">补充文档</span>
          </div>
        </Upload>
      </div>
    );
  }
;

export default DocxParser;